<template inline-template>
	<div class="infoLayout mainLayout">
		<section class="info">
			<h1>Maggiori informazioni</h1>
			<h2 id="info-tech">Tecnologie</h2>
			<h3>PWA</h3>
			<p>Questo sito è una <a href="https://developers.google.com/web/progressive-web-apps/" target="_blank">PWA</a>
			come definito da Google ultimamente, ossia è una applicazione web con funzionalità aggiuntive:</p>
			<p>
				<ul>
					<li>Funziona offline (parzialmenmte: i video non sono visibili da youtuibe mentre si è offline, ma si possono vedere l'elenco dei video e le loro miniature)</li>
					<li>Puo essere "installata" sul device attraverso la funzionalita "add to homescreen"</li>
					<li>Permette di essere caricata piu' velocemente</li>
				</ul>
			</p>
			<p>Nota: 
				la disponibilita' dei contenuti offline dipende anche dal browser in uso: consiglio di usare Chrome, 
				Opera o Firefox alle ultime versioni per usufruire al meglio dei contenuti.
			</p>
			<h3>JAM</h3>
			<p>Inotre utilizza lo stack JAM che consiste in 3 principali componenti:</p>
			<p>
				<ol>
					<li><strong>J</strong>: javascript come linguaggio base</li>
					<li><strong>A</strong>: API per passare informazioni ed interagire con la piattaforma</li>
					<li><strong>M</strong>: Markup per creare i template che state vedendo</li>
				</ol>
			</p>
			<h3>Hosting e sviluppo</h3>
			<p>Questa web app è resa disponibile grazie a:</p>
			<p>
				<ol>
					<li><strong>Vuejs</strong>: Framework javascript - <a href="https://vuejs.org/" target="_blank">link</a></li>
					<li><strong>Webpack</strong>: Bundler javascript - <a href="https://webpack.github.io/" target="_blank">link</a></li>
					<li><strong>Netlify</strong>: Hosting html e file statici - <a href="https://www.netlify.com/" target="_blank">link</a></li>
					<li><strong>Firebase Realtime db</strong>: database usato per mostrare i video aggiunti dalla community - <a href="https://firebase.google.com/" target="_blank">link</a></li>
					<li><strong>Firebase Cloud functions</strong>: API permettere l'interazione con la web application: voti e aggiunta di video - <a href="https://firebase.google.com/" target="_blank">link</a></li>
				</ol>
			</p>
		</section>
	</div>
</template>
<style lang="less">
	.info{
		background-color: white;
		padding: 25px;
		text-align:left;
		color: #222;
		line-height: 1.5;
			box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);
			margin-bottom: 150px;
		h1{
			font-family: 'Freckle Face', cursive;
			font-weight: 400 !important;
			// border-bottom: 1px solid green;
			margin-top:0;
			background-color: #666;
			color:white;
			padding: 25px;
			padding-bottom: 10px;
			margin-left:-25px;
			margin-top:-25px;
			margin-right:-25px;
		}
		p{
			font-family: 'Open Sans', sans-serif;
		}
	}
</style>
<script>
	export default {
		name: 'info',
		data () {
			return {
				videos: [

				]
			}
		},
		beforeDestroy: function(){
			if((this.$root)&&(this.$root.closeMenu)){
				this.$root.closeMenu()
			}
		}
	}
</script>


// WEBPACK FOOTER //
// info.vue?4f75706f